
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"label.state.<ABORTED>":"Vorgang abgebrochen","label.state.<FAILED>":"(Fehlgeschlagen)"},"en":{"label.state.<ABORTED>":"Process aborted","label.state.<FAILED>":"(Failed)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();